import React from "react";
import { motion } from "framer-motion";
import { Users } from "lucide-react";
import { SectionHeader } from "@/components/site/primitives";
import { fadeUp, stagger } from "@/lib/motion";
import { COMMUNITIES } from "@/data";
import { useCommunities } from "@/components/communities/context/CommunitiesContext";
import JoinButton from "@/components/communities/JoinButton";

const toneDot = { coral: "bg-coral", yellow: "bg-yellow", sage: "bg-sage", blue: "bg-blue" };

export default function PopularCommunities() {
  const { communities } = useCommunities();
  const featured = COMMUNITIES.slice(0, 6).map((seedCommunity) => ({
    ...seedCommunity,
    apiCommunity: communities.find((community) => (
      community.id === seedCommunity.id || community.name?.toLowerCase() === seedCommunity.name?.toLowerCase()
    )),
  }));
  return (
    <section className="u-container mt-14 md:mt-20" data-testid="home-communities">
      <SectionHeader eyebrow="Where the conversation is loudest" title="Popular in Communities" />
      <motion.div variants={stagger} initial="hidden" animate="show" className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {featured.map((c, i) => (
          <motion.div key={c.name} variants={fadeUp} custom={i} className="card-paper flex flex-col gap-3 p-5">
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2 font-display text-base font-semibold text-ink">
                <span className={`h-2 w-2 rounded-full ${toneDot[c.tone]}`} /> {c.name}
              </span>
              <span className="flex items-center gap-1 text-xs font-medium text-subtle"><Users className="h-3.5 w-3.5" /> {c.members}</span>
            </div>
            <p className="text-sm text-subtle">Everyone's talking about <span className="font-medium text-ink/80">{c.talking}</span>.</p>
            {c.apiCommunity ? (
              <JoinButton community={c.apiCommunity} size="sm" className="mt-1 w-fit" />
            ) : (
              <span className="mt-1 w-fit rounded-full border border-line px-4 py-1.5 text-xs font-semibold text-subtle">
                Unavailable
              </span>
            )}
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
